/**
 * ---------maintenance history-------------
 * 07/10/2019 By Ella Ma: remove the IM Handle and IM Service(TAM-26439)
 * 12/24/2019 By Yoyo: move out entity/entry column list to  tile-column-settings.model for sharing
 */

import { Component, OnInit, Input, OnDestroy, HostListener, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { TileColumn, TileColumnGroupSetting, TileColumnType, TileColumnDataType, COLORS } from '../../../../tamalelibs/models/tile-column.model';
import { Subject, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { ContextMenuConfig, ContextMenuShowAction } from '../../../../widgets/tam-context-menu/tam-context-menu.model';
import { LONG_TOUCH_INTERVAL } from '../../../../tamalelibs/constants/business.constants';
import { DeviceDetectorService } from 'ngx-device-detector';
import { TileSettingService } from '../../../../services/tile-setting.service';
import { IdHelperService } from '../../../../services/id-helper.service';
import { select, Store } from '@ngrx/store';
import { adhocDBSelector } from '../../../../redux/reducers/adhoc.reducer';
import { AppState } from '../../../../redux';
import { Adhoc } from '../../../../tamalelibs/models/adhoc.model';
import * as _ from 'lodash';
import { EMPTY_FORMULA_COLUMN, EMPTY_MDL_COLUMN, EMPTY_RELATIONSHIP_COLUMN } from '../../../../tamalelibs/models/tile-column.model';
import { BriefConfig } from '../../../../widgets/widgets.model';
import { TileColumnSettingEvents } from '../tile-setting.model';
import { CONTACT_COLUMN_LIST, DEFAULT_ITEM_HEIGHT, ENTITY_COLUMN_LIST, ENTRY_COLUMN_LIST } from './tile-column-setting.model';
import { fullEntryTypeSelector } from '../../../../redux/reducers/entry-type.reducer';
import { EntryType } from '../../../../tamalelibs/models/entry-type.model';
import { TileModel } from '../../../../tamalelibs/models/tile.model';
import { businessConstants } from '../../../../constants/business.constants';
import { ArrayHelperService } from '../../../../tamalelibs/services/array-helper.service';

const COLOR_NUMBER = 31;

@Component({
    selector: 'tam-tile-column-setting',
    templateUrl: './tile-column-setting.component.html',
    styleUrls: ['./tile-column-setting.component.scss']
})
export class TileColumnSettingComponent implements OnInit, OnDestroy {

    @Input() config: TileModel;
    @Input() actionSubject$: Subject<any>;

    @ViewChild('keywordForAddInput', { static: false })
    keywordForAddInputEle: ElementRef;
    @ViewChild('addListContainer', { static: false })
    addListContainerEle: ElementRef;

    selectedColumn: TileColumn;
    selectedColumnGroup: TileColumnGroupSetting;
    selectedColumnForGroup: TileColumn;
    selectedColumnIndexForAdd: number;
    contextMenuConfig: ContextMenuConfig;
    isIPAD = false;
    keywordForAdd: string;
    showAddPopup1 = false;
    showAddPopup2 = false;
    addSearchResult: Array<TileColumn> = [];
    columnSearchResult: Array<TileColumn> = [];
    showError = false;
    keywordForColumn: string;
    colors = [].concat(COLORS);
    briefConfig: BriefConfig = new BriefConfig();
    canShowThreadSameRow: boolean;

    private _destroySubscriptions: Subscription[] = [];
    private _touchstart: number;
    private _columnList: Array<TileColumn> = [];
    private _entryTypeList: Array<EntryType> = [];
    private _startDateColumn: TileColumn = {
        field: 'entry__display_date',
        name: 'Start Date',
        title: 'Start Date',
        dataType: TileColumnDataType.DATE,
        top: 0,
        columnType: TileColumnType.ENTRY_COLUMN,
        guid: '',
        settings: {
            display: '1',
        },
        hidden: false,
        formattingConfig: {},
    };
    private _entryColumnList: Array<TileColumn> = null;
    private _entityColumnList: Array<TileColumn> = null;
    private _contactColumnList: Array<TileColumn> = null;
    private _columnColors = new Map();

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _deviceService: DeviceDetectorService,
        private _store: Store<AppState>,
    ) {
        this.isIPAD = this._deviceService.isMobile() || this._deviceService.isTablet();
        this._entryColumnList = _.cloneDeep(ENTRY_COLUMN_LIST);
        this._entityColumnList = _.cloneDeep(ENTITY_COLUMN_LIST);
        this._contactColumnList = _.cloneDeep(CONTACT_COLUMN_LIST);
    }

    ngOnInit() {
        // this.selectedColumn = this.config.columns[0];
        this._store.pipe(
            select(adhocDBSelector),
            take(1),
        ).subscribe((data: Map<string, Adhoc>) => {
            const adhocs: Array<Adhoc> = data ? Array.from(data.values()) : [];
            const tempList: Array<TileColumn> = [this._startDateColumn];
            adhocs.forEach(adhoc => {
                tempList.push(TileSettingService.generateColumnForAdhocDB(adhoc));
            });
            ArrayHelperService.sort(tempList, 'name');
            this._entryColumnList.push(...tempList);
        });
        this._store.pipe(
            select(fullEntryTypeSelector),
            take(1),
        ).subscribe(res => {
            this._entryTypeList = res;
        });
        this._initContextMenu();
        this._destroySubscriptions.push(
            this.briefConfig.feedbackSubject$.subscribe(event => {
                this._initCanShowThreadSameRow();
                this._resetEntitiesSameRow();

                if (this.config.columnGroups) {
                    this.config.columnGroups.forEach(item => {
                        if (this.selectedColumnGroup && item.id === this.selectedColumnGroup.id) {
                            if (event.type === TileColumnSettingEvents.COLUMN_GROUP_OPTIONS_CHANGE) {
                                item.display = this.selectedColumnGroup.display;
                            } else if (event.type === TileColumnSettingEvents.COLUMN_GROUP_FILTER_CHANGE ||
                                event.type === TileColumnSettingEvents.COLUMN_GROUP_NOTE_TYPE_CHANGE) {
                                item.filters = this.selectedColumnGroup.filters;
                            }
                        }
                    });
                }
            }),
        );
        this._initCanShowThreadSameRow();
        this._resetEntitiesSameRow();
        this._initGroupColors();
    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    @HostListener('document:click', ['$event'])
    clickSomewhere(event) {
        if (this.showAddPopup1) {
            this.showAddPopup1 = false;
        }
        if (this.showAddPopup2) {
            this.showAddPopup2 = false;
        }
    }

    addColumn(event) {
        this.showAddPopup1 = !this.showAddPopup1;
        this.showAddPopup2 = false;
        this.emptyClick(event);
    }

    addContactColumn(event) {
        this._columnList = this._contactColumnList;
        this.addSearchResult = this._columnList;
        this.selectedColumnIndexForAdd = 0;
        this.showAddPopup2 = true;
        this.showAddPopup1 = false;
        this.emptyClick(event);
        this.keywordForAdd = '';
        setTimeout(() =>
            this.keywordForAddInputEle.nativeElement.focus()
        );
    }

    addEntityColumn(event) {
        this._columnList = this._entityColumnList;
        this.addSearchResult = this._columnList;
        this.selectedColumnIndexForAdd = 0;
        this.showAddPopup2 = true;
        this.showAddPopup1 = false;
        this.emptyClick(event);
        this.keywordForAdd = '';
        setTimeout(() =>
            this.keywordForAddInputEle.nativeElement.focus()
        );
    }

    addFormulaColumn(event) {
        this.showAddPopup1 = false;
        this.showAddPopup2 = false;
        const column: TileColumn = _.cloneDeep(EMPTY_FORMULA_COLUMN);
        delete column.field;
        this.onAddColumnClick(event, column);
    }

    addMDLColumn(event) {
        this.showAddPopup1 = false;
        this.showAddPopup2 = false;
        this.onAddColumnClick(event, EMPTY_MDL_COLUMN);
    }

    addNoteColumn(event) {
        this._columnList = this._entryColumnList;
        this.addSearchResult = this._columnList;
        this.selectedColumnIndexForAdd = 0;
        this.showAddPopup2 = true;
        this.showAddPopup1 = false;
        this.emptyClick(event);
        this.keywordForAdd = '';
        setTimeout(() =>
            this.keywordForAddInputEle.nativeElement.focus()
        );
    }

    addRelationshipColumn(event) {
        this.showAddPopup1 = false;
        this.showAddPopup2 = false;
        this.onAddColumnClick(event, EMPTY_RELATIONSHIP_COLUMN);
    }

    emptyClick($event) {
        if ($event.preventDefault) {
            $event.preventDefault();
        }
        if ($event.stopPropagation) {
            $event.stopPropagation();
        }
    }

    getColor(column: TileColumn): string {
        let color: string;
        if (column.groupIndex) {
            color = this._columnColors.get(column.groupId);
        }
        return color;
    }

    onAddColumnClick($event, item: TileColumn) {
        const column: TileColumn = _.cloneDeep(item);
        if (item.field === businessConstants.dashboard.field.entry_file) {
            const shortId = TileSettingService.generateShortId(this.config.columns);
            column.guid = item.guid + shortId;
        } else {
            column.guid = TileSettingService.generateShortId(this.config.columns);
        }

        this.config.columns.push(column);
        if (this.keywordForColumn && this.columnSearchResult && column.title.toLowerCase().includes(this.keywordForColumn.toLowerCase())) {
            this.columnSearchResult.push(column);
        }
        this.selectedColumn = column;
        this.selectedColumnForGroup = null;
        this.selectedColumnGroup = null;
        this.emptyClick($event);
    }

    onAddListKeydown(event) {
        // use up/down/enter to select through items
        if (event.keyCode === 40) { // down
            if (this.selectedColumnIndexForAdd < this.addSearchResult.length - 1) {
                this.selectedColumnIndexForAdd++;
                const nextIndex = this.selectedColumnIndexForAdd + 1;
                if (nextIndex < this.addSearchResult.length) {
                    if ((nextIndex + 1) * DEFAULT_ITEM_HEIGHT > (this.addListContainerEle.nativeElement.clientHeight + this.addListContainerEle.nativeElement.scrollTop)) {
                        // handle tha case that selected item below the visible area
                        this.addListContainerEle.nativeElement.scrollTop = (nextIndex + 1) * DEFAULT_ITEM_HEIGHT - this.addListContainerEle.nativeElement.clientHeight;
                    } else if (this.addListContainerEle.nativeElement.scrollTop > (nextIndex + 1) * DEFAULT_ITEM_HEIGHT) {
                        // handle the case that selected item above the visible area
                        this.addListContainerEle.nativeElement.scrollTop = nextIndex * DEFAULT_ITEM_HEIGHT;
                    }
                }
            }
        } else if (event.keyCode === 38) { // up
            if (this.selectedColumnIndexForAdd > 0) {
                this.selectedColumnIndexForAdd--;
                const nextIndex = this.selectedColumnIndexForAdd - 1;
                if (nextIndex >= 0) {
                    if ((nextIndex + 1) * DEFAULT_ITEM_HEIGHT > (this.addListContainerEle.nativeElement.clientHeight + this.addListContainerEle.nativeElement.scrollTop)) {
                        // handle tha case that selected item below the visible area
                        this.addListContainerEle.nativeElement.scrollTop = (nextIndex + 1) * DEFAULT_ITEM_HEIGHT - this.addListContainerEle.nativeElement.clientHeight;
                    } else if (this.addListContainerEle.nativeElement.scrollTop > nextIndex * DEFAULT_ITEM_HEIGHT) {
                        // handle the case that selected item above the visible area
                        this.addListContainerEle.nativeElement.scrollTop = nextIndex * DEFAULT_ITEM_HEIGHT;
                    }
                }
            }
        } else if (event.keyCode === 13) { // Enter
            this.onAddColumnClick(event, this.addSearchResult[this.selectedColumnIndexForAdd]);
        }
    }

    onChangeShowEveryEntity(value) {
        this.config.options.showRowForEveryEntity = value;
        if (value) {
            this.config.columns.forEach(item => {
                if (item.default) {
                    item.showEntitiesSameRow = false;
                }
            });
        }
    }

    onColumnClick(dataItem) {
        this.selectedColumnForGroup = null;
        this.selectedColumnGroup = null;
        if (!this.selectedColumn || this.selectedColumn.guid !== dataItem.guid) {
            this.selectedColumn = dataItem;
        } else {
            this.selectedColumn = null;
        }
    }

    onColumnGroupClick($event, dataItem) {
        this.selectedColumn = null;
        let selectedColumnChanged = false;
        if (!this.selectedColumnForGroup || this.selectedColumnForGroup.guid !== dataItem.guid) {
            this.selectedColumnForGroup = dataItem;
            selectedColumnChanged = true;
        }
        if (!this.selectedColumnGroup) {
            this.selectedColumnGroup = this.config.columnGroups.find(item => item.id === dataItem.groupId);
        } else if (this.selectedColumnGroup.id !== dataItem.groupId) {
            this.selectedColumnGroup = this.config.columnGroups.find(item => item.id === dataItem.groupId);
        } else {
            this.selectedColumnGroup = selectedColumnChanged ? this.selectedColumnGroup : null;
        }
        if ($event.preventDefault) {
            $event.preventDefault();
        }
        if ($event.stopPropagation) {
            $event.stopPropagation();
        }
    }

    onContextMenu(event, column: TileColumn, index: number) {
        if (column.columnType === TileColumnType.ENTRY_COLUMN) {
            this.contextMenuConfig.items = [
                { id: '0', text: 'Remove this column' }
            ];
            if (this.config.columnGroups && this.config.columnGroups.length > 0) {
                this.contextMenuConfig.items.push({ divider: true });
                const columnGroups = this._resortColumnGroups();
                columnGroups.forEach((group: TileColumnGroupSetting, i, groups) => {
                    let tempIdList: Array<string> = [];
                    if (group.filters && group.filters.filters && group.filters.filters.length > 0 && group.filters.filters[0] && group.filters.filters[0].value) {
                        let tempStr: string = group.filters.filters[0].value.substring(2);
                        tempStr = tempStr.substring(0, tempStr.length - 2);
                        tempIdList = tempStr.split('\',\'');
                    }
                    let tempText = this._entryTypeList.filter(item => tempIdList.includes(item.id)).map(item => item.name).join(', ');
                    if (tempText.length > 52) {
                        tempText = tempText.substring(0, 50) + '...';
                    }
                    this.contextMenuConfig.items.push({ id: group.id, text: tempText, icon: 'cycle', iconColor: this._columnColors.get(group.id) });
                });
                this.contextMenuConfig.items.push({ divider: true });
            }
            if (column.groupId) {
                this.contextMenuConfig.items.push({ id: '1', text: 'Remove Note Column Group' });
            } else {
                this.contextMenuConfig.items.push({ id: '2', text: 'Add Note Column Group' });
            }
            let index2 = -1;
            if (this.columnSearchResult && this.columnSearchResult.length > 0) {
                index2 = this.columnSearchResult.findIndex(item => item.guid === column.guid);
            }
            this.contextMenuConfig.show$.next(new ContextMenuShowAction(event, { column: column, index: index, index2: index2 }));
        } else if (!column.default) {
            this.contextMenuConfig.items = [
                { id: '0', text: 'Remove this column' }
            ];
            let index2 = -1;
            if (this.columnSearchResult && this.columnSearchResult.length > 0) {
                index2 = this.columnSearchResult.findIndex(item => item.guid === column.guid);
            }
            this.contextMenuConfig.show$.next(new ContextMenuShowAction(event, { column: column, index: index, index2: index2 }));
        } else {
            if (event.preventDefault) {
                event.preventDefault();
            }
            if (event.stopPropagation) {
                event.stopPropagation();
            }
        }
        this._changeDetectorRef.detectChanges();
    }

    onContextMenu2(event, column: TileColumn, index2: number) {
        if (column.columnType === TileColumnType.ENTRY_COLUMN) {
            this.contextMenuConfig.items = [
                { id: '0', text: 'Remove this column' }
            ];
            if (this.config.columnGroups && this.config.columnGroups.length > 0) {
                this.contextMenuConfig.items.push({ divider: true });
                const columnGroups = this._resortColumnGroups();
                columnGroups.forEach((group: TileColumnGroupSetting, i, groups) => {
                    let tempIdList: Array<string> = [];
                    if (group.filters && group.filters.filters && group.filters.filters.length > 0 && group.filters.filters[0] && group.filters.filters[0].value) {
                        let tempStr: string = group.filters.filters[0].value.substring(2);
                        tempStr = tempStr.substring(0, tempStr.length - 2);
                        tempIdList = tempStr.split('\',\'');
                    }
                    let tempText = this._entryTypeList.filter(item => tempIdList.includes(item.id)).map(item => item.name).join(', ');
                    if (tempText.length > 52) {
                        tempText = tempText.substring(0, 50) + '...';
                    }
                    this.contextMenuConfig.items.push({ id: group.id, text: tempText, icon: 'cycle', iconColor: this._columnColors.get(group.id) });
                });
                this.contextMenuConfig.items.push({ divider: true });
            }
            if (column.groupId) {
                this.contextMenuConfig.items.push({ id: '1', text: 'Remove Note Column Group' });
            } else {
                this.contextMenuConfig.items.push({ id: '2', text: 'Add Note Column Group' });
            }
            const index = this.config.columns.findIndex(item => item.guid === column.guid);
            this.contextMenuConfig.show$.next(new ContextMenuShowAction(event, { column: column, index: index, index2: index2 }));
        } else if (!column.default) {
            this.contextMenuConfig.items = [
                { id: '0', text: 'Remove this column' }
            ];
            const index = this.config.columns.findIndex(item => item.guid === column.guid);
            this.contextMenuConfig.show$.next(new ContextMenuShowAction(event, { column: column, index: index, index2: index2 }));
        } else {
            if (event.preventDefault) {
                event.preventDefault();
            }
            if (event.stopPropagation) {
                event.stopPropagation();
            }
        }
        this._changeDetectorRef.detectChanges();
    }

    onSearchAddKeyup(event) {
        const keyCode = event.keyCode;
        if (keyCode !== 13 && keyCode !== 38 && keyCode !== 40) {
            this._searchAddList();
        }
    }

    onSearchColumnKeyup(event) {
        const keyCode = event.keyCode;
        if (keyCode !== 13 && keyCode !== 38 && keyCode !== 40) {
            this._searchColumnList();
        }
    }

    // For iPad
    touchstart() {
        this._touchstart = new Date().getTime();
    }

    // For iPad
    touchend(event, column: TileColumn, index: number) {
        if (this.isIPAD && new Date().getTime() - this._touchstart > LONG_TOUCH_INTERVAL) {
            event.clientX = event.pageX;
            event.clientY = event.pageY;
            this.onContextMenu(event, column, index);
        }
    }

    // For iPad
    touchend2(event, column: TileColumn, index: number) {
        if (this.isIPAD && new Date().getTime() - this._touchstart > LONG_TOUCH_INTERVAL) {
            event.clientX = event.pageX;
            event.clientY = event.pageY;
            this.onContextMenu2(event, column, index);
        }
    }

    trackByFn(index) {
        return index;
    }

    validate() {
        this.showError = true;
        this.config.columns.forEach(item => {
            if (item.conditionalFormattings) {
                item.conditionalFormattings.forEach((value, index, array) => {
                    if (!value.formula || !value.formulaForData) {
                        array.splice(index, 1);
                    }
                });
                if (item.conditionalFormattings.length === 0) {
                    delete item.conditionalFormattings;
                }
            }
        });
        const length = this.config.columns.length;
        for (let i = 0; i < length; i += 1) {
            const column = this.config.columns[i];
            if (!column.title.trim() || column.title.trim().length > 32) {
                return false;
            }
            if (column.columnType === TileColumnType.ENTITY_COLUMN && !column.default) {
                if (!column.config || !column.config.parameterValue) {
                    return false;
                }
            } else if (column.columnType === TileColumnType.CONTACT_COLUMN) {
                if (!column.config || !column.config.parameterValue) {
                    return false;
                }
            } else if (column.columnType === TileColumnType.RELATIONSHIP_COLUMN) {
                if (!column.relationshipType || !column.config || !column.config.parameterValue) {
                    return false;
                }
            } else if (column.columnType === TileColumnType.MDL_COLUMN) {
                if (!column.config || !column.config.provider || !column.config.parameterValue || !column.field) {
                    return false;
                }
            } else if (column.columnType === TileColumnType.FORMULA_COLUMN) {
                if (!column.formula || !column.formulaForData) {
                    return false;
                }
            }
        }
        if (this.config.columnGroups && this.config.columnGroups.length > 0) {
            return !this.config.columnGroups.some(item => (!item.filters || !item.filters.filters || item.filters.filters.length === 0 || !item.filters.filters[0] || !item.filters.filters[0].value));
        }
        return true;
    }

    private _addColumnGroup(column: TileColumn, index: number) {
        const groupId = IdHelperService.createGUID(1);
        const group = new TileColumnGroupSetting(groupId);
        this.config.columnGroups.push(group);
        this.config.columns[index].groupId = groupId;
        const len = this.config.columnGroups.length;
        this.config.columns[index].groupIndex = len;
        this.selectedColumn = null;
        this.selectedColumnForGroup = column;
        this.selectedColumnGroup = group;
        this._columnColors.set(groupId, this.colors[(len - 1) & COLOR_NUMBER]);
        this._initCanShowThreadSameRow();
    }

    private _changeColumnGroup(id: string, index: number) {
        const groupIndex = this.config.columnGroups.findIndex(item => item.id === id);
        if (groupIndex > -1) {
            this.config.columns[index].groupId = id;
            this.config.columns[index].groupIndex = groupIndex + 1;
        }
    }

    private _initContextMenu() {
        this.contextMenuConfig = new ContextMenuConfig();
        this.contextMenuConfig.stateful = false;
        this.contextMenuConfig.showItemIcon = true;
        this.contextMenuConfig.forceRefresh = true;
        this._destroySubscriptions.push(this.contextMenuConfig.events$.subscribe(event => this._onMenuSelect(event)));
    }

    private _initCanShowThreadSameRow() {
        const tempGroupList: Array<TileColumnGroupSetting> = this.config.columnGroups.filter(item => item.display === 0);
        this.canShowThreadSameRow = tempGroupList && tempGroupList.length > 1;
        if (!this.canShowThreadSameRow) {
            this.config.options.showRowAsThread = false;
        }
    }

    private _initGroupColors() {
        this.config.columns.forEach(item => {
            if (item.groupId) {
                this._columnColors.set(item.groupId, this.colors[(item.groupIndex - 1) & COLOR_NUMBER]);
            }
        });
    }

    private _onMenuSelect(event) {
        const type = event.payload.id;
        const column = event.payload.data.column;
        const index = event.payload.data.index;
        const index2 = event.payload.data.index2;
        switch (type) {
            case '0':
                this._removeColumn(column, index, index2);
                break;
            case '1':
                this._removeColumnFromGroup(column, index);
                break;
            case '2':
                this._addColumnGroup(column, index);
                break;
            default:
                this._changeColumnGroup(type, index);
                break;
        }
    }

    private _removeColumn(column: TileColumn, index: number, index2: number) {
        const tempColumn = this.config.columns.splice(index, 1)[0];
        if (index2 > -1) {
            this.columnSearchResult.splice(index2, 1);
        }
        if (column.groupId) {
            if (!this.config.columns.some(item => item.groupId === column.groupId)) {
                this.config.columnGroups.splice(column.groupIndex - 1, 1);
                this._columnColors.delete(column.groupId);
                this._resetColorsOrder(column.groupIndex - 1);
                this._initCanShowThreadSameRow();
            }
        }
        this.config.columns.forEach(item => {
            if (item && item.config && item.config.parameterValue === tempColumn.guid) {
                delete item.config.parameterValue;
            }
            if (item.groupId) {
                // keep column groupIndex equal to columnGroups index.
                const i = this.config.columnGroups.findIndex(group => group.id === item.groupId);
                if (i !== -1) {
                    item.groupIndex = i + 1;
                }
            }
        });
        // Notifies data changes to the parent form
        this.actionSubject$.next(tempColumn);
    }

    private _removeColumnFromGroup(column: TileColumn, index: number) {
        const groupId = this.config.columns[index].groupId;
        const groupIndex = column.groupIndex;
        delete this.config.columns[index].groupId;
        delete this.config.columns[index].groupIndex;
        if (!this.config.columns.some(item => item.groupId === groupId)) {
            this.config.columnGroups.splice(groupIndex - 1, 1);
            this._columnColors.delete(groupId);
            this._resetColorsOrder(groupIndex - 1);
            this._initCanShowThreadSameRow();
        }
        // keep column groupIndex equal to columnGroups index.
        this.config.columns.forEach((item) => {
            if (item.groupId) {
                const i = this.config.columnGroups.findIndex(group => group.id === item.groupId);
                if (i !== -1) {
                    item.groupIndex = i + 1;
                }
            }
        });
    }

    private _resetEntitiesSameRow() {
        const tempGroupList: Array<TileColumnGroupSetting> = this.config.columnGroups.filter(item => item.display !== 0);
        const entitiesSameRowDisabled = tempGroupList && tempGroupList.length > 0;
        if (entitiesSameRowDisabled) {
            this.config.columns.forEach(item => {
                if (item.default) {
                    item.showEntitiesSameRow = false;
                }
            });
        }
    }

    private _resortColumnGroups() {
        // when open context menu, menu item color should be order as same as column item, column item  can move, delete, add
        const groups = new Map();
        this.config.columns.forEach(item => {
            if (item.groupId) {
                const tempGroup = this.config.columnGroups.find(group => group.id === item.groupId);
                if (tempGroup) {
                    groups.set(tempGroup.id, tempGroup);
                }
            }
        });
        // remove dulplicate item
        return Array.from(groups.values());
    }

    /**
     *
     * @param index
     * requirements: if I remove a group, the existing column group colours should not change and when delete a column group
     * for example: if [groupA, groupB, groupC]->[red, green, blue], remove groupA, then add groupA, so the group array is [groupB, groupC, groupA],
     * groupB and groupC color should not change, at this time groupA color is blue, as same as groupC, is not expect, so keep exist groups color not change and a new group's color is different from exist groups, so re-order color arr.
     */
    private _resetColorsOrder(index) {
        const color = this.colors[index & COLOR_NUMBER];
        this.colors.splice(index, 1);
        this.colors.splice(COLOR_NUMBER, 0, color);
    }

    private _searchAddList() {
        this.selectedColumnIndexForAdd = 0;
        if (this.keywordForAdd) {
            this.addSearchResult = [];
            this._columnList.forEach(item => {
                if (item.title.toLowerCase().includes(this.keywordForAdd.toLowerCase()) || item.name.toLowerCase().includes(this.keywordForAdd.toLowerCase())) {
                    this.addSearchResult.push(item);
                }
            });
        } else {
            this.addSearchResult = this._columnList;
        }
    }

    private _searchColumnList() {
        this.columnSearchResult = [];
        if (this.keywordForColumn) {
            this.config.columns.forEach(item => {
                if (item.title.toLowerCase().includes(this.keywordForColumn.toLowerCase()) || item.name.toLowerCase().includes(this.keywordForColumn.toLowerCase())) {
                    this.columnSearchResult.push(item);
                }
            });
        }
    }
}
